export const AssetCategoryValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.AssetCategory.trim()) {
      errors.AssetCategory = 'Asset Category is required';
    } 
  
    return errors;
  };
  
 